import useVuexModule from '@shared/composables/vuexModule.js'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { computed } from 'vue'

// TODO: Partial implementation (ENG-2843)
export const useAccountStore = defineStore('account', () => {
  const vuex = useVuexModule('account', {
    defaults: {
      state: [
        ['pickupConfirmationCode', null],
        ['pickupLocations', []],
        ['localPickupLocations', []],
        ['breadcrumbs', []],
        ['actionHeaderText', 'Account'],
        ['itemPromotions', null]
      ],
      actions: [
        'setBreadcrumbs',
        'setActionHeaderText'
      ]
    }
  })

  const { breadcrumbs } = vuex

  const currentLocation = computed(() => {
    return breadcrumbs.value.length > 0 ? breadcrumbs.value[breadcrumbs.value.length - 1].name : ''
  })

  return {
    ...vuex,
    currentLocation
  }
})

import.meta.hot?.accept(acceptHMRUpdate(useAccountStore, import.meta.hot))
